import React from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';
import ConfirmEmail from 'features/auth/ui/Auth/ConfirmEmail';
import {isEmailConfirmingSelector} from 'entities/user';

const ConfirmEmailScreen: React.FC = () => {
    const isLoading = useSelector(isEmailConfirmingSelector);

    return (
        <BlankLayout pageTitle={t`Подтверждение email`} isLoading={isLoading}>
            <ConfirmEmail/>
        </BlankLayout>
    );
};

export default ConfirmEmailScreen;
